import { buildComputePayload } from './computePayload'

// What autosave may write: the compute body (same parse rules, same allow-lists) minus scenarioType,
// which is create-only (D14). title and activeTemplate are already outside the compute body.
export function buildSavePayload(scenario) {
  const { scenarioType, ...body } = buildComputePayload(scenario)
  return body
}

const same = (a, b) => JSON.stringify(a ?? null) === JSON.stringify(b ?? null)

// Only the leaves that differ from what the server holds; toggles one key at a time, since the
// PATCH writes `toggles.<key>` per key. null when nothing differs.
export function diffSavePayload(saved, next) {
  const out = {}
  for (const [key, value] of Object.entries(next)) {
    if (key === 'toggles') continue
    if (!same(saved?.[key], value)) out[key] = value
  }
  const toggles = {}
  for (const [key, value] of Object.entries(next.toggles ?? {})) {
    if (!same(saved?.toggles?.[key], value)) toggles[key] = value
  }
  if (Object.keys(toggles).length > 0) out.toggles = toggles
  return Object.keys(out).length > 0 ? out : null
}

// The server's copy after a successful PATCH of `diff`.
export function mergeSavePayload(saved, diff) {
  return {
    ...saved,
    ...diff,
    toggles: { ...(saved?.toggles ?? {}), ...(diff.toggles ?? {}) },
  }
}

// The leaves of a save body as 'key' or 'toggles.<key>', the unit the PATCH writes.
export function saveLeaves(diff) {
  const leaves = Object.keys(diff).filter((key) => key !== 'toggles')
  for (const key of Object.keys(diff.toggles ?? {})) leaves.push(`toggles.${key}`)
  return leaves
}

// `diff` with the named leaves added at their value in `next`, whether or not they differ.
export function withLeaves(diff, next, leaves) {
  const out = { ...(diff ?? {}) }
  for (const leaf of leaves) {
    if (leaf.startsWith('toggles.')) {
      const key = leaf.slice('toggles.'.length)
      if (next.toggles && key in next.toggles) out.toggles = { ...(out.toggles ?? {}), [key]: next.toggles[key] }
    } else if (leaf in next) {
      out[leaf] = next[leaf]
    }
  }
  return Object.keys(out).length > 0 ? out : null
}
